import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRich from "csi/heading/StringRich";
import declare from "dojo/_base/declare";

const CareAndCompositionLanguageStringMapRenderer = declare(StringRich, {
	/**
	 * @override
	 * Display node names as a string instead of a ref
	 */
	toValue(ctx: Context, h: Heading): string {
		return ctx.getNodeContext().CompositionsPerLanguage[ctx.getNode().SysID];
	},

});

export = CareAndCompositionLanguageStringMapRenderer;